import { Button, ButtonGroup, Typography, Box, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, TextField } from "@mui/material";
import React, { useState } from "react";
import PropTypes from "prop-types";
import StepperButtons from "../StepperButtons";
import { advancePhase } from "../ProjectActions";
import { useDispatch } from "react-redux";

export default function StartDesignPhase({ payload }) {
    const dispatch = useDispatch();
    const [phase, setPhase] = useState(0);
    const [customPhaseName, setCustomPhaseName] = useState("");

    const handleStartDesignPhase = () => {
        let phase_name;
        if (phase == 0) {
            phase_name = "Verkenningsfase";
        } else if (phase == 1) {
            phase_name = "Planuitwerkingsfase";
        } else {
            phase_name = customPhaseName;
        }
        advancePhase(payload.project.id, phase, phase_name, dispatch);
    };

    return (
        <>
            <Box>
                <Typography variant="body1" gutterBottom>
                    U kunt nu de ontwerpfase starten. In deze fase gaat u aan de slag met het ontwerpen van een oplossing voor uw project.
                </Typography>
                
                {payload.project.phases.length === 0 && payload.editable && (
                    <Box sx={{ mt: 2, mb: 2 }}>
                        <FormControl>
                            <FormLabel id="phase-name-radio-buttons-group-label">Selecteer een naam voor de fase, of voer zelf een optie in.</FormLabel>
                            <RadioGroup
                                row
                                aria-labelledby="phase-name-radio-buttons-group-label"
                                defaultValue="0"
                                name="phase-name-radio-buttons-group"
                                onChange={(event) => {
                                    setPhase(event.target.value);
                                }}
                            >
                                <FormControlLabel value="0" control={<Radio />} label="Verkenningsfase" />
                                <FormControlLabel value="1" control={<Radio />} label="Planuitwerkingsfase" />
                                <FormControlLabel value="2" control={<Radio />} label="Anders" />
                            </RadioGroup>
                            {phase == 2 && (
                                <TextField
                                    value={customPhaseName}
                                    onChange={(event) => {
                                        setCustomPhaseName(event.target.value);
                                    }}
                                    placeholder="Vul een ontwerp fase naam in"
                                    sx={{ mt: 1, maxWidth: 300 }}
                                />
                            )}
                        </FormControl>
                    </Box>
                )}
                
                <ButtonGroup>
                    <Button 
                        variant="contained"
                        onClick={handleStartDesignPhase} 
                        disabled={payload.project.phases.length > 0 || !payload.editable || (phase == 2 && !customPhaseName.trim())}
                    >
                        {payload.project.phases.length > 0 ? "Ontwerpfase is reeds gestart" : "Start ontwerpfase"}
                    </Button>
                </ButtonGroup>
            </Box>
            <StepperButtons payload={payload} updateStatus={false} warningPopup={false} />
        </>
    );
}

StartDesignPhase.propTypes = {
    payload: PropTypes.object.isRequired,
};
